<div class="container-fluid">
  <div class="row h-100">
    <main class="main-container col-sm overflow-auto vh-100 m-0">
      <div class="row header-container">
        <img priority src="/assets/herc-logo.svg" class="logo"
              alt="Herc Rentals logo" width="160" height="40">
      </div>

      <div class="content-wrapper">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>
